import { Box, Checkbox, css, FormControlLabel, FormGroup, IconButton, Paper, styled } from '@mui/material';

import LayersIcon from '@/assets/icons/layers.svg?react';
import { AdminModeControl } from '@/components/map/AdminModeControl';
import { LAYERS } from '@/modules/Layers';
import { useMapStore } from '@/stores/useMapStore';
import { useUserStore } from '@/stores/useUserStore';

const Root = styled(Box)(
  () => css`
    &:hover {
      .layers-control-button {
        display: none;
      }

      .layers-control-paper {
        display: block;
      }
    }
  `,
);

const StyledPaper = styled(Paper)(
  ({ theme }) => css`
    display: none;
    padding: ${theme.spacing(2)};
  `,
);

const StyledIconButton = styled(IconButton)(
  ({ theme }) => css`
    border-radius: ${theme.spacing(1)};
    color: ${theme.palette.primary.main};
    background-color: ${theme.palette.primary.main};
  `,
);

export function LayersControl() {
  const layersControl = useMapStore((state) => state.layersControl);
  const { updateLayersControl } = useMapStore((state) => state.actions);
  const adminMode = useUserStore((state) => state.adminMode);

  return (
    <Root>
      <StyledIconButton className="layers-control-button" size="small">
        <LayersIcon height={24} style={{ color: 'black' }} width={24} />
      </StyledIconButton>

      <StyledPaper className="layers-control-paper">
        <FormGroup>
          {Object.entries(LAYERS).map(([key, { label, disabled }]) => (
            <FormControlLabel
              key={key}
              disabled={disabled}
              label={label}
              control={
                <Checkbox
                  checked={layersControl[key as keyof typeof layersControl]}
                  onChange={(_, checked) => updateLayersControl({ [key]: checked })}
                  size="small"
                />
              }
            />
          ))}
        </FormGroup>

        {adminMode ? <AdminModeControl /> : null}
      </StyledPaper>
    </Root>
  );
}
